import { render, staticRenderFns } from "./DebtStats.vue?vue&type=template&id=7e42a9d0&"
import script from "./DebtStats.vue?vue&type=script&lang=js&"
export * from "./DebtStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports